import React from 'react'
import Portal from '../../../../component/portal'
import './index.scss'
import { getSeckillList } from '../../../../component/service'
import { getImgUrl, formatTimeForSeckill, i18n, getUnitForSeckill } from '../../../../common/util'
import { AppContext } from '../../../../config/context'

class Seckill extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            show: false,
            hour: '00',
            min: '00',
            sec: '00',
            list: [],
            page: 1,
            totalPage: 1,
            windowStyle: { left: '0' },
            pp: '',
            sa: ''
        }
        this.timer = null
        this.errorTime = 0
    }

    componentDidMount() {
        this.init()
    }

    init = () => {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
        if (this.errorTime > 3) {
            return
        }
        this.setState({
            hour: '00',
            min: '00',
            sec: '00'
        })
        getSeckillList().then(({ activityType, activityId, timestamp, now, timeTerm, timeTermUnit, goodsList: list, shelveFlag }) => {
            const show = shelveFlag === 1
            if (!show) {
                return this.setState({
                    show
                })
            }
            const timerInfo = getUnitForSeckill(timeTermUnit)
            const endTime = timestamp + timerInfo.value * timeTerm
            let seconds = Math.ceil((endTime - now) / 1000)
            if (seconds <= 0) {
                throw new Error('activity timeout')
            }
            this.errorTime = 0
            this.setState({
                show,
                ...formatTimeForSeckill(seconds),
                list,
                page: 1,
                totalPage: Math.ceil(list.length / 5),
                windowStyle: { left: '0' },
                pp: `${timeTerm}${timerInfo.label}/场`,
                sa: `?seacba=${activityType}-${activityId}-${timestamp.toString(16)}`
            })
            this.timer = setInterval(() => {
                --seconds
                if (seconds >= 0) {
                    this.setState(formatTimeForSeckill(seconds))
                }
                if (seconds <= 0) {
                    this.init()
                }
            }, 1000)
            // _sr('show', '橱窗', '限时秒杀', list.map(g => g.goodsName))
        }).catch(e => {
            this.tryInit(e)
        })
    }

    tryInit = e => {
        console.error(e)
        this.errorTime++
        setTimeout(() => { this.init() }, 1000)
    }

    goToPage = newPage => {
        const { page, totalPage } = this.state
        if (newPage !== page && newPage >= 1 && newPage <= totalPage) {
            this.setState({
                page: newPage,
                windowStyle: {
                    left: `${0 - (newPage - 1) * 1010}px`
                }
            })
        }
    }

    render() {
        const { show, hour, min, sec, list, windowStyle, page, totalPage, pp, sa } = this.state
        const { lang } = this.context.user
        return show ? <div>
            <h2 className="sec-page-title">{i18n('限时秒杀', lang)}</h2>
            <div className="steam-seckill-container">
                <div className="steam-seckill-bg"></div>
                <div className="seckill-timer-wrapper">
                    <p className="seckill-timer-tip"><span className="highlight">{i18n(pp, lang)}</span>{i18n('倒计时', lang)}</p>
                    <ul className="seckill-timer-ul">
                        <li className="seckill-timer time">{hour}</li>
                        <li className="seckill-timer">:</li>
                        <li className="seckill-timer time">{min}</li>
                        <li className="seckill-timer">:</li>
                        <li className="seckill-timer time">{sec}</li>
                    </ul>
                </div>
                <div className="seckill-list-window">
                    <ul className="seckill-list-ul" style={windowStyle}>
                        {
                            list.map((item, i) => (<a target="_blank" href={`/p/${item.goodsId}.html${sa}`} key={item.goodsId} st-btn="1" st-category="营销活动" st-label="限时秒杀" st-action="click" st-value={JSON.stringify([{ goodsId: item.goodsId, goodsName: item.goodsName }])} st-element-id={`seckill-list-${i}`}>
                                <li className="seckill-item">
                                    <img alt="" className="seckill-item-img" src={getImgUrl(item.mainPic)}></img>
                                    <div className="seckill-mask">
                                        <p className="seckill-item-name">{i18n(item.goodsName, lang)}</p>
                                        <div className="seckill-item-price">
                                            <span className="price"><span className="yen">&yen;</span>{item.priceAfterDiscount}</span>
                                            <span className="op">&yen;{item.primePrice}</span>
                                        </div>
                                    </div>
                                </li>
                            </a>))
                        }
                    </ul>
                    <i className={page > 1 ? 'seckill-slide left' : 'seckill-slide left disabled'} onClick={() => this.goToPage(page - 1)}></i>
                    <i className={page < totalPage ? 'seckill-slide right' : 'seckill-slide right disabled'} onClick={() => this.goToPage(page + 1)}></i>
                </div>
            </div>
        </div> : null
    }
}

Seckill.contextType = AppContext
export default Portal(Seckill, 'steam-seckill-container')